import { useMemo } from 'react';
import { AccountFlows } from '@shared/api';

export const useAccountFlow = (flows?: AccountFlows[], accountId?: number) => {
  return useMemo(() => {
    if (!flows?.length || !accountId) return undefined;
    return flows.find((flow) => flow.accountId === accountId);
  }, [flows, accountId]);
};
